/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from 'react-redux';

import { convertToJson } from '../../../Common/utils';
import { getCurrentVisitPayloadDetails } from '../../selectors';

const useVisitPayloadTab = () => {
  const visitTab = useSelector(getCurrentVisitPayloadDetails);
  const visitPayloadInfo = convertToJson(visitTab);

  return visitPayloadInfo;
};

export default useVisitPayloadTab;
